import { Injectable, signal, inject } from '@angular/core';
import { ProjectOption } from '../models/navigation.model';
import { ThemeService } from './theme.service';

export const MOCK_PROJECTS: readonly ProjectOption[] = [
  { id: 'proj-1', name: 'ERP System Upgrade', code: 'ERP-UG', category: 'Enterprise' },
  { id: 'proj-2', name: 'Customer Portal V2', code: 'CP-V2', category: 'Web App' },
  { id: 'proj-3', name: 'Internal IT Service Desk', code: 'ITS-DESK', category: 'Infrastructure' },
  { id: 'proj-4', name: 'Mobile App Support', code: 'MOB-SUP', category: 'Mobile' }
];

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  private readonly themeService = inject(ThemeService);

  /** Sidebar collapsed state for desktop (icon-only mode) */
  readonly isSidebarCollapsed = signal<boolean>(false);

  /** Sidebar completely hidden state (mobile & desktop) */
  readonly isSidebarHidden = signal<boolean>(false);

  /** Mobile drawer open state for mobile/tablet */
  readonly isMobileDrawerOpen = signal<boolean>(false);

  /** Notification slide-over panel open state */
  readonly isNotificationPanelOpen = signal<boolean>(false);

  /** Global loading overlay visible state */
  readonly isLoadingOverlayVisible = signal<boolean>(false);

  /** Current active project selector */
  readonly activeProject = signal<ProjectOption>(MOCK_PROJECTS[0]);

  /** Theme mode (light / dark) */
  get theme() {
    return this.themeService.currentTheme;
  }

  /** List of available projects */
  readonly projects = signal<readonly ProjectOption[]>(MOCK_PROJECTS);

  toggleSidebar(): void {
    this.isSidebarHidden.update((v) => !v);
  }

  toggleSidebarCollapse(): void {
    this.isSidebarCollapsed.update((v) => !v);
  }

  hideSidebar(): void {
    this.isSidebarHidden.set(true);
  }

  showSidebar(): void {
    this.isSidebarHidden.set(false);
  }

  toggleMobileDrawer(): void {
    this.isMobileDrawerOpen.update(v => !v);
  }

  closeMobileDrawer(): void {
    this.isMobileDrawerOpen.set(false);
  }

  toggleNotificationPanel(): void {
    this.isNotificationPanelOpen.update(v => !v);
  }

  closeNotificationPanel(): void {
    this.isNotificationPanelOpen.set(false);
  }

  setLoadingOverlay(visible: boolean): void {
    this.isLoadingOverlayVisible.set(visible);
  }

  setActiveProject(project: ProjectOption): void {
    this.activeProject.set(project);
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }
}

